export default "__VITE_ASSET__B9059Fn$__"